import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { ThrowClassNameToChildren } from "../HiddenPanel/ThrowClassNameToChild";

interface PanelRootProps {
    wide: boolean;
    shadow: boolean;
}

export const PanelRoot = styled.div<PanelRootProps>(
    props => ({
        height: "100%",
        maxHeight: "100%",
        overflow: "hidden",
        backgroundColor: theme(props).keyPalette.panelBackgroundColor,
        borderRight: theme(props).border.solid,
        zIndex: 899,
        boxSizing: "content-box",
        width: theme(props).pageLayout.sidebar.width.css(),
        display: "flex",
        flexDirection: "column",
    }),
    props =>
        props.wide && {
            width: theme(props).pageLayout.sidebar.wideModeWidth.css(),
        },
    props =>
        props.shadow && {
            boxShadow: `0 0 8px 0 ${theme(props).legacy.shadowColor}`,
        }
);

export const EMBEDDED_PANEL_HEIGHT = 65;
export const PanelHeader = styled.div<{ embedded: boolean; isReadOnly?: boolean }>(props => ({
    height: props.isReadOnly ? 41 : props.embedded ? EMBEDDED_PANEL_HEIGHT : 41,
    position: "relative",
    boxSizing: "border-box",
    borderBottom: "1px solid transparent",
    justifyContent: "space-between",
    flexGrow: 0,
    flexShrink: 0,
    padding: "19px 0 0 19px",
    display: "flex",
}));

export const PinContainer = styled(ThrowClassNameToChildren)({
    position: "absolute",
    top: 6,
    right: 6,
});

export const PANEL_INDENT = 5;
export const PanelContent = styled(ThrowClassNameToChildren)({
    flex: "1 1 100%",
    paddingTop: PANEL_INDENT,
    width: "100%",
    overflow: "hidden",
});
